import * as types from '../actionTypes';
import PrivateAPIResource from "../../services/PrivateAPIResource";

export function loadPortalsCategoriesSuccess(categories) {
    return {type: types.LOAD_PORTALS_CATEGORIES_SUCCESS, categories};
}

export function loadInterestsSuccess(interests) {
    return {type: types.LOAD_INTERESTS_SUCCESS, interests};
}

export function updateInterestsSuccess(interests) {
    return {type: types.UPDATE_INTERESTS_SUCCESS, interests};
}

export function loadPortalsCategories() {
    return function(dispatch) {
        return PrivateAPIResource.get('interests')
            .then(categories => {
                dispatch(loadPortalsCategoriesSuccess(categories));
            });
    }
}

export function updateInterests(userId, interests) {
    return function(dispatch) {
        return PrivateAPIResource.put(`interests/${userId}`, interests)
            .then(categories => {
                dispatch(updateInterestsSuccess(categories));
            });
    }
}

export function loadInterests(userId) {
    return function(dispatch) {
        return PrivateAPIResource.all(`interests/${userId}`)
            .then(interests => {
                dispatch(loadInterestsSuccess(interests));
            });
    }
}


// WEBPACK FOOTER //
// ./web/src/actions/interests/interestsActions.js